import * as React from 'react';
import { storyblokEditable, type SbBlokData } from '@storyblok/react';

import type { ServiceLinkStoryblok, StoryblokMultilink } from '../../types/storyblok';

interface ServiceLinkProps {
  blok: ServiceLinkStoryblok;
}

/**
 * Resolves the href from a Storyblok multilink field.
 */
const resolveLinkHref = (link: StoryblokMultilink | undefined): string | null => {
  if (!link) return null;
  const href = link.cached_url || link.url;
  return href || null;
};

/**
 * ServiceLink renders a club name for North America member cards.
 * Renders as link if URL provided, otherwise as plain text.
 */
export const ServiceLink: React.FC<ServiceLinkProps> = ({ blok }) => {
  const href = resolveLinkHref(blok.url as StoryblokMultilink | undefined);

  if (!blok.label) {
    return null;
  }

  // Render as plain text if no URL
  if (!href) {
    return (
      <span
        {...storyblokEditable(blok as unknown as SbBlokData)}
        className="block text-sm text-gray-700"
      >
        {blok.label}
      </span>
    );
  }

  return (
    <a
      {...storyblokEditable(blok as unknown as SbBlokData)}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="block text-callout font-medium text-gray-700 hover:text-brand-blue hover:underline transition-colors"
    >
      {blok.label}
    </a>
  );
};
